import { makeAutoObservable, runInAction } from 'mobx';

export class RouteStore {
    lastRoute: string | null = null;

    constructor() {
        makeAutoObservable(this);

        const saved = localStorage.getItem('lastRoute');
        if (saved) 
            this.lastRoute = saved;

        window.addEventListener('storage', (event) => {
            if (event.key === 'lastRoute') {
                runInAction(() => {
                    this.lastRoute = event.newValue;
                });
            }
        });
    }

    setLastRoute(route: string) {
        this.lastRoute = route;
        localStorage.setItem('lastRoute', route);
    }

    clearLastRoute() {
        this.lastRoute = null;
        localStorage.removeItem('lastRoute');
    }

    setFromLocation() {
        this.setLastRoute(location.pathname);
    }
}
